var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ReactElementFactory } from "survey-react-ui";
import { ActionButton } from "../ActionButton";
var QuestionBanner = /** @class */ (function (_super) {
    __extends(QuestionBanner, _super);
    function QuestionBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuestionBanner.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "svc-carry-forward-panel-wrapper" },
            React.createElement("div", { className: "svc-carry-forward-panel" },
                React.createElement("span", null,
                    this.props.text,
                    " "),
                React.createElement("span", { className: "svc-carry-forward-panel__link" },
                    React.createElement(ActionButton, { click: function () { return _this.props.onClick(); }, text: this.props.actionText })))));
    };
    return QuestionBanner;
}(React.Component));
export { QuestionBanner };
ReactElementFactory.Instance.registerElement("svc-question-banner", function (props) {
    return React.createElement(QuestionBanner, props);
});
